import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  setLoginType(data) {
    return Axios({
      url: requestPrefix.centerUrl + '/users/setLoginType',
      method: 'get',
      params: data
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/jump/index.js